//Common
import { POSICAO_MENU } from "@/common/constantes";
import { fn_removerAcentuacao } from "@/common/utils/util";

/*
 * Funções de apoio do menu do sistema (no topo, em header.jsx, ou na lateral, em menu_lateral.jsx).
 */

/*
 * Retorna a posição do menu (no topo ou na lateral) guardada na sessão no login.
 * Vem da parametrização global POSICAO_MENU (tabela parametrizacao, vale para todos os clientes).
 * Sem o valor na sessão (sessão aberta antes da parametrização) ou com valor inválido, o menu fica na lateral.
 */
export function fn_getPosicaoMenu(sessaoUsuario) {
  const posicao = sessaoUsuario?.posicao_menu;

  return Object.values(POSICAO_MENU).includes(posicao)
    ? posicao
    : POSICAO_MENU.LATERAL;
}

//Retorna a rota do item de menu (o link da tela, a rota da tela ou a rota do item)
export function fn_getRotaItemMenu(item) {
  return item?.tela?.link || item?.tela?.rota || item?.rota || null;
}

//Texto para comparar na pesquisa do menu: sem acento, maiúsculo e sem espaço nas pontas
export function fn_getTextoPesquisaMenu(texto) {
  return fn_removerAcentuacao(String(texto ?? ""))
    .toUpperCase()
    .trim();
}

/*
 * Filtra os menus pela pesquisa do nome da tela (item do menu), sem diferenciar acento nem maiúscula/minúscula.
 * Retorna os menus que têm item encontrado, só com esses itens. Se o texto for o nome do menu, traz todos os itens dele.
 * Sem texto, retorna os menus como estão.
 */
export function fn_filtrarMenusPesquisa(menus, texto) {
  const pesquisa = fn_getTextoPesquisaMenu(texto);

  if (!Array.isArray(menus)) return [];
  if (!pesquisa) return menus;

  return menus
    .map((menu) => {
      const isMenuEncontrado = fn_getTextoPesquisaMenu(menu.nome).includes(
        pesquisa,
      );

      const itens = (menu.itens || []).filter(
        (item) =>
          isMenuEncontrado ||
          fn_getTextoPesquisaMenu(item.nome).includes(pesquisa),
      );

      return { ...menu, itens };
    })
    .filter((menu) => menu.itens.length > 0);
}

/*
 * Divide o nome em partes para destacar o trecho pesquisado: [{ texto, destaque }].
 * A comparação é sem acento e sem diferenciar maiúscula/minúscula, mas as partes mantêm o nome original.
 */
export function fn_getPartesDestaquePesquisaMenu(nome, texto) {
  const original = String(nome ?? "");
  const pesquisa = fn_getTextoPesquisaMenu(texto);
  const comparacao = fn_removerAcentuacao(original).toUpperCase();

  //A remoção do acento mantém a quantidade de letras: a posição encontrada vale para o nome original
  const inicio = pesquisa ? comparacao.indexOf(pesquisa) : -1;

  if (inicio < 0 || comparacao.length != original.length) {
    return [{ texto: original, destaque: false }];
  }

  const fim = inicio + pesquisa.length;

  return [
    { texto: original.slice(0, inicio), destaque: false },
    { texto: original.slice(inicio, fim), destaque: true },
    { texto: original.slice(fim), destaque: false },
  ].filter((parte) => parte.texto);
}

//Indica se o item de menu é o da tela aberta (pela rota da página atual)
export function fn_isItemMenuAtivo(item, pathname) {
  const rota = fn_getRotaItemMenu(item);

  return rota != null && pathname == rota;
}
